module.exports = __webpack_public_path__ + "static/img/chat-today-user-pick-bg.345af88.png";